// src/oura/tasks/flag.ts
//
// Whether Delivery > Tasks and the Timeline upload's "Tasks Oura makes" show.
// Fails closed: on when VITE_ENABLE_OURA_TASKS is exactly "true", or on a local
// fixtures run (the dev server with VITE_ENABLE_OURA_LIVE_API unset). Until the
// tasks routes and the Google Sheet sync ship, both read sample rows.

export const TASKS_ON = import.meta.env.VITE_ENABLE_OURA_TASKS === "true" || (import.meta.env.DEV && import.meta.env.VITE_ENABLE_OURA_LIVE_API !== "true");

// Whether the Tasks tab reads the client's real tasks (ourteam-frontend#4681,
// backend epic #6480): GET /businesses/{id}/tasks and the link, read-now and
// change routes. Exactly "true" turns it on; off (or absent) keeps the sample
// rows, unchanged. Turn it on only where the backend routes are deployed. Never on
// without TASKS_ON: the parent switch off changes nothing.
export const TASKS_LIVE = TASKS_ON && import.meta.env.VITE_ENABLE_OURA_TASKS_LIVE === "true";

// Whether "Add a task" and the task drawer's Delete show on the live Tasks tab
// (ourteam-frontend#4751, backend #6621: POST and DELETE /businesses/{id}/tasks).
// Exactly "true" turns them on, and only with TASKS_LIVE. Off (or absent) the
// table is what it was before. Turn it on only where backend #6621 is deployed.
export const TASKS_WRITE_ROWS = TASKS_LIVE && import.meta.env.VITE_ENABLE_OURA_TASKS_ROWS === "true";
